// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__6WV9W","mainContent":"PageLayout_mainContent__ge-3k","header":"PageLayout_header__HVfoR","footer":"PageLayout_footer__RfOSB"};